// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"92577a35","679":"db776a56","703":"6f22903a","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};